const topics = [
  { tag: '爆', title: '某顶流男星深夜密会三人，酒店监控视频流出引热议', category: '明星黑料', time: '3小时前', hot: true },
  { tag: '新', title: '知名女艺人片场耍大牌遭群演集体爆料，导演组沉默', category: '剧组内幕', time: '5小时前', hot: false },
  { tag: '热', title: '社交平台大规模封号，多位网红账号涉不良内容被清', category: '网红翻车', time: '6小时前', hot: true },
  { tag: '追', title: '某综艺节目录制现场选手互殴，节目组紧急公关删帖', category: '综艺争议', time: '8小时前', hot: false },
  { tag: '爆', title: '娱乐圈知名夫妻被曝已分居半年，双方团队拒绝回应', category: '明星婚姻', time: '10小时前', hot: true },
  { tag: '新', title: '热门影视剧原著作者被扒抄袭，剧组表态启动调查程序', category: '影视争议', time: '12小时前', hot: false },
  { tag: '热', title: '某流量小生代言翻车，产品被曝质量问题粉丝集体维权', category: '商业风波', time: '14小时前', hot: true },
  { tag: '追', title: '知名导演新片片场发生安全事故，多方回应说法不一', category: '突发事件', time: '16小时前', hot: false },
  { tag: '新', title: '某女团成员被曝与经纪公司对簿公堂，解约内幕曝光', category: '合约纠纷', time: '18小时前', hot: true },
];

export default function SectionIndex() {
  return (
    <section id="index" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">今日热瓜</h2>
          <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full font-semibold whitespace-nowrap">实时追踪</span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10 pl-4">一手黑料爆料，娱乐圈最新动态一网打尽，吃瓜群众每日必刷瓜田</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group block bg-background-50 rounded-lg p-4 md:p-5 hover:bg-primary-50/50 transition-colors border border-background-200/70 cursor-pointer"
            >
              <div className="flex items-start gap-3">
                <span
                  className={`shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-md text-xs font-bold whitespace-nowrap ${
                    item.tag === '爆'
                      ? 'bg-primary-500 text-white'
                      : item.tag === '热'
                      ? 'bg-accent-500 text-white'
                      : item.tag === '追'
                      ? 'bg-secondary-500 text-white'
                      : 'bg-foreground-100 text-foreground-600'
                  }`}
                >
                  {item.tag}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2 mb-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">{item.category}</span>
                    <span>{item.time}</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}